import React from 'react';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import { REDUCER_NAME, changePutThrough } from './../../reducer';

const mapStateToProps = state => {
  return {
    currentPutThrough: state[REDUCER_NAME].currentPutThrough,
    listPutThrough: state[REDUCER_NAME].listPutThrough,
    listPutThroughByKey: state[REDUCER_NAME].listPutThroughByKey,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = {
  changePutThrough,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Filter);

function Filter(props) {
  return (
    <DropDown
      id={props.watchListId}
      keyTitle="name"
      listKey={props.listPutThrough}
      listDataByKey={props.listPutThroughByKey}
      currentKey={props.currentPutThrough}
      change={props.changePutThrough}
      isI18n={true}
    />
  );
}
